
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import DoughnutChart from '@/components/shared/charts/DoughnutChart.vue';

@Component<OrdersSummary>({
	components: {
		DoughnutChart
	}
})
export default class OrdersSummary extends Vue {
	@Getter('getOrdersSummary', { namespace: 'dashboard' }) private ordersSummary!: OrdersSummaryType;

	$refs!: {
		doughnutChart: DoughnutChart;
	};

	/**
	 * Generate chart data for doughnut chart visualization
	 * Transforms orders summary into Chart.js compatible format with status-based colors
	 * Shows grey placeholder segment when no orders exist
	 *
	 * @return {DoughnutChartData}
	 */
	private get chartData(): DoughnutChartData {
		const updatedData = {
			labels: [
				this.$t('orders.management.parent_card.order_card.pending'),
				this.$t('orders.management.parent_card.order_card.in_progress'),
				this.$t('orders.management.parent_card.order_card.completed')
			],
			datasets: [
				{
					backgroundColor: ['#FBCFD0', '#FFF0CA', '#D3FAF1', '#EDEDED'],
					data: [
						this.ordersSummary?.statusCounts?.pending || 0,
						this.ordersSummary?.statusCounts?.inProgress || 0,
						this.ordersSummary?.statusCounts?.completed || 0,
						this.ordersSummary?.totalOrders > 0 ? 0 : 1 // Show a single grey segment when there are no orders
					]
				}
			]
		};
		// Update existing chart if component is already mounted
		if (this.$refs.doughnutChart) {
			this.$refs.doughnutChart.updateChartData(updatedData);
		}
		return updatedData;
	}
}
